<template>
   <div>
     <ad></ad>
     <div class="content">
       <inner-nav :innerData="navList[2]" :innerTitle="innerTitle"></inner-nav>
       <div class="news-content">
         <div class="news-detail">
           <div class="news-list">
             <ul>
               <li v-for="(item,index) in newsList" :key="index" @click="itemDetail(item.content,item.id)">
                 <img v-if="item.urlList" :src="item.urlList[0]" alt="">
                 <div>
                   <h3>{{item.title}}</h3>
                   <div class="content-ellipsis">{{item.content | delHtmlTag}}</div>
                 </div>
                 <i></i>
               </li>
             </ul>
           </div>
           <div class="new-img">
             <img v-for="(item,index) in adList" :key="index" :src="item.imgUrl" alt="">
           </div>
         </div>
         <div class="news-pagination">
           <el-pagination
             background
             layout="prev, pager, next"
             @current-change="changePage"
             :total="totalPage">
           </el-pagination>
         </div>

       </div>
     </div>
   </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  import {mapGetters,mapActions} from "vuex";

  export default {
      name: "",
      data(){
          return {
            count:0,
            newsNoticeList:[],
            innerTitle: "公告列表"
          }
      },
      components: {
        ad,
        InnerNav
      },
      filters: {
        delHtmlTag(str){
          if (str){
            var s=str.replace(/<[^>]*>|/g,"");
            return s.replace(/&nbsp;/ig, "");//去掉所有的html标记
          }
        }
      },
      computed: {
        ...mapGetters('newsNotice', ['newsList','totalPage']),
        ...mapGetters(['adList'])
      },
      methods:{
        ...mapActions('newsNotice',['newsListFn']),
        ...mapActions(['adListFn']),
        itemDetail(detail,id){
//          this.$store.commit( 'newsNotice/newsDetailFn',{detail:detail,id:id} )
          this.$router.push({path:`/main/newsNotice/newsDetail?id=${id}`});
        },
        changePage(e){
          this.newsListFn(e);
        }
      },
      created(){
        this.newsListFn(1);
        this.adListFn();
        console.log(this.totalPage,'totalPage')
      }
    }
</script>

<style scoped lang="less">
  .news-content{
    overflow: hidden;
    clear: both;
    padding-bottom:.3rem;
    padding-top:.3rem;
      .news-detail{
        overflow: hidden;
        clear: both;
          .news-list{
            width:7.7rem;
            float: left;
              li{
                position: relative;
                clear: both;
                overflow: hidden;
                border:.01rem solid #D8D8D8;
                margin-top:.1rem;
                  i{
                    position: absolute;
                    top:0;
                    right:-.01rem;
                    width:.02rem;
                    height:0rem;
                    background: #F53A37;
                    transition: height .4s ease;
                    -webkit-transition: height .4s ease;/* Safari */
                  }
                  img{
                    width:2.69rem;
                    height:1.46rem;
                    float: left;
                  }
                  >div{
                     overflow: hidden;
                     float: right;
                     padding:.1rem .3rem;
                     -webkit-box-sizing: border-box;
                     -moz-box-sizing: border-box;
                     box-sizing: border-box;
                     height:1.46rem;
                     width:4.93rem;
                      h3{
                        font-family:PingFangSC-Medium;
                        font-weight:500;
                        font-size:.16rem;
                        color: #333;
                        line-height:.36rem;
                      }
                      div{
                        text-align: justify;
                        padding-top:.03rem;
                        font-size:.14rem;
                        color: #666;
                        line-height:.22rem;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        display:-webkit-box;
                        -webkit-line-clamp:3;
                        -webkit-box-orient:vertical;
                      }
                      .content-ellipsis{
                        position:relative;
                        height:.66rem;
                        overflow:hidden;
                      }
                      .content-ellipsis:after{
                        content:"...";
                        position:absolute;
                        bottom:0;
                        right:0;
                        padding:0 0 1px .45rem;
                        background:url('/static/img/ellipsis_bg.png') repeat-y;
                      }
                  }

              }
              li:hover{
                background:#eeeeee;
                cursor: pointer;
                  .content-ellipsis:after{
                    background:none;
                  }
                  i{
                    height:100%;
                  }
              }

          }
      }

      .new-img{
        width:4rem;
        float: right;
        img{
          width: 4rem;
          height:2.6rem;
          margin-top:.1rem;
        }
      }
  }


</style>

<style lang="less">
  .news-pagination{
    text-align: center;
    padding-top:.4rem;
      .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #F53A37;
      }
      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
        border-radius: 50%;
        height: .24rem;
        width:.24rem;
        min-width: .24rem;
        line-height:.24rem;
      }
      .el-pagination.is-background .el-pager li:not(.disabled):hover{
        color: #000;
      }
      .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
        background-color: #F53A37;
        color: #fff;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/news/newsNotice.vue